import firebase from "firebase/app";
import 'firebase/firestore';   // for cloud firestore
import 'firebase/analytics';   // for cloud firestore


var firebaseConfig = {
  apiKey: "AIzaSyCE3l_4YXiwp5xEsBI-AQ_ySflPQZrjuko",
  authDomain: "portfolio-contact-page-data.firebaseapp.com",
  databaseURL: "https://portfolio-contact-page-data.firebaseio.com",
  projectId: "portfolio-contact-page-data",
  storageBucket: "portfolio-contact-page-data.appspot.com",
  messagingSenderId: "836093174936",
  appId: "1:836093174936:web:a2f38fb5841cdf2fe01ced",
  measurementId: "G-47SB0TNJXM",
};
// Initialize Firebase
var firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();

var db = firebaseApp.firestore();

export { db };
